// NewProduct.js
// Component for adding a new product

// Imports
import React from 'react';
import EditableText from '../Common/EditableText';
import PropTypes from 'prop-types';

// Component Class
// Shows an editable text that, when edited, adds a new product
class NewProduct extends React.Component {
  // Renders Component
  render() {
    return (
      <EditableText
        value=""
        clearAfterSet
        placeholder="Clique para adicionar um novo produto"
        rename={this.props.add}
        minWidth="200"
      />
    );
  }
}

// Required Properties
NewProduct.propTypes = {
  add: PropTypes.func.isRequired,
}

// Exports
export default NewProduct;



// WEBPACK FOOTER //
// ./src/components/ProductView/NewProduct.js